import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { cn, isFunction } from '../utils';

const KTModal = ({
  anchor = 'right',
  children,
  className = '',
  closeOnEsc = true,
  disableOutsideClick = false,
  isOpen = false,
  onClose = () => {},
}) => {
  const modalContent = useRef(null);
  const [isModalOpen, setIsModalOpen] = React.useState(isOpen);

  const contentClass = [
    className,
    `sc-drawer-content sc-drawer-${anchor}`,
  ].join(' ');

  const closeModal = () => {
    setIsModalOpen(false);

    if (isFunction(onClose)) {
      onClose();
    }
  };

  const handleKeydown = event => {
    if (
      isModalOpen &&
      closeOnEsc &&
      (event.key === 'Escape' || event.keyCode === 27 || event.which === 27)
    ) {
      closeModal();
    }
  };

  const onContainerClick = event => {
    let mouseDrag = false;
    let mouseClick = false;
    let dbClicked = false;

    if (isModalOpen || disableOutsideClick) return;

    if (modalContent && modalContent.current.contains(event.target)) return;

    document.addEventListener('mousedown', () => {
      mouseClick = true;
    });

    document.addEventListener('mousemove', () => {
      mouseDrag = true;
    });

    document.addEventListener('dblclick', () => {
      dbClicked = true;
    });

    document.addEventListener('mouseup', () => {
      if (dbClicked) {
        return;
      }

      if (mouseClick && !mouseDrag && !dbClicked) {
        closeModal();
      }

      mouseDrag = false;
      mouseClick = false;
      dbClicked = false;
    });

    closeModal();
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeydown);

    return () => document.removeEventListener('keydown', handleKeydown);
  }, []);

  useEffect(() => setIsModalOpen(isOpen), [isOpen]);

  return (
    <div
      role="presentation"
      className={cn({
        'sc-drawer': true,
        'sc-drawer-visible': isModalOpen,
        'sc-drawer-hidden': !isModalOpen,
      })}
      onMouseDown={onContainerClick}
    >
      <div ref={modalContent} className={contentClass}>
        {children}
      </div>
    </div>
  );
};

KTModal.propTypes = {
  anchor: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  className: PropTypes.string,
  closeOnEsc: PropTypes.bool,
  children: PropTypes.node,
  disableOutsideClick: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default KTModal;
